import axios from 'axios'

const DraftService = {
  async get (params = {}) {
    return axios.get('po/purchase-order/drafts', { params })
  },

  async show (id) {
    return axios.get(`po/purchase-order/drafts/${id}`)
  },

  async post (params = {}) {
    return axios.post('po/purchase-order/drafts', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`po/purchase-order/drafts/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`po/purchase-order/drafts/${data.id}`, { data })
  }
}

export default DraftService
